import importerReducers from 'modules/shared/importer/importerReducers';
import actions from 'modules/customer/importer/customerImporterActions';

export default importerReducers(actions);
